import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import StyledLowestPriceAddendum from './styles';
var LowestPriceAddendum = function LowestPriceAddendum() {
  var $ = _c(3);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      stringKey: "podium_lowest_price",
      primaryValue: "Lowest Price",
      description: "A note near the price that indicates the discounted price is the lowest price, a requirement in PL and other geos"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var lowestPrice = useI18nString(t0);
  var t1;
  if ($[1] !== lowestPrice) {
    t1 = /*#__PURE__*/React.createElement(StyledLowestPriceAddendum, {
      className: "lowest-price-addendum"
    }, lowestPrice);
    $[1] = lowestPrice;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default LowestPriceAddendum;